import styled from 'styled-components'

import { IconProps } from '@/components/Icons'
import BaseSvg from '@/components/Icons/BaseSvg'

const StyledIcon = styled<any>(BaseSvg)`
  width: 20px;
  height: 20px;
`
const RunFeatureIcon = (props: IconProps) => (
  <StyledIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.875 4C3.83947 4 3 4.83947 3 5.875V9.625C3 10.6605 3.83947 11.5 4.875 11.5H10.25V11.7222C10.25 12.9649 11.2574 13.9722 12.5 13.9722C12.9142 13.9722 13.25 14.308 13.25 14.7222V15H7.375C6.33947 15 5.5 15.8395 5.5 16.875V19.125C5.5 20.1605 6.33947 21 7.375 21H19.375C20.4105 21 21.25 20.1605 21.25 19.125V16.875C21.25 15.8395 20.4105 15 19.375 15H14.75V14.7222C14.75 13.4796 13.7426 12.4722 12.5 12.4722C12.0858 12.4722 11.75 12.1364 11.75 11.7222V11.5H17.625C18.6605 11.5 19.5 10.6605 19.5 9.625V5.875C19.5 4.83947 18.6605 4 17.625 4H4.875ZM4.5 5.875C4.5 5.66789 4.66789 5.5 4.875 5.5H17.625C17.8321 5.5 18 5.66789 18 5.875V9.625C18 9.83211 17.8321 10 17.625 10H4.875C4.66789 10 4.5 9.83211 4.5 9.625V5.875ZM7 16.875C7 16.6679 7.16789 16.5 7.375 16.5H19.375C19.5821 16.5 19.75 16.6679 19.75 16.875V19.125C19.75 19.3321 19.5821 19.5 19.375 19.5H7.375C7.16789 19.5 7 19.3321 7 19.125V16.875Z"
      fill="#002AB4"
    />
  </StyledIcon>
)

RunFeatureIcon.displayName = 'UIView'
export default RunFeatureIcon
